<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>转产统计列表</b></p>

        </div>

        <el-table :data="changeProdList" style="width: 100%" ref="plasticTable" highlight-current-row>

            <el-table-column prop="equipmentName" label="设备名称" min-width="10%">
            </el-table-column>

            <el-table-column prop="completeMan" label="完成操作人" min-width="10%">
            </el-table-column>

            <el-table-column prop="completeTime" label="完成时间" min-width="10%">
            </el-table-column>
            <el-table-column prop="operateFunction" label="上模操作人" min-width="10%">
            </el-table-column>
            <el-table-column prop="operateModule" label="上模完成时间" min-width="10%">
            </el-table-column>
            <el-table-column prop="startMan" label="调机员" min-width="10%">
            </el-table-column>
            <el-table-column prop="startTime" label="调机时间" min-width="10%">
            </el-table-column>
            <el-table-column prop="checkMan" label="首检人" min-width="10%">
            </el-table-column>
            <el-table-column prop="checkTime" label="首检完成时间" min-width="10%">
            </el-table-column>

            <el-table-column prop="totalTime" label="转产总时间(m)" min-width="10%" align="center">
            </el-table-column>

        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="total, sizes, prev, pager, next"
                :total="total" @current-change="pageClick" :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

    </div>
</template>

<script>
export default {
    name: "ChangeProdStatistic",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),

            changeProdList: [],

            queryValue: '',

            loading: false,
            formLabelWidth: '120px',

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0,
        }
    },
    methods: {
        selectMaker() {
            this.getAll()
        },
        getAll() {

            this.$axios({
                method: "post",
                url: "/shiro/upper/mold/statistic",
                data: {
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.changeProdList = data.data
                this.total = this.changeProdList[0].total
                for (let i in this.changeProdList) {
                    this.changeProdList[i].completeTime = this.$moment(this.changeProdList[i].completeTime).format("YYYY-MM-DD HH:mm")

                    this.changeProdList[i].startTime = this.$moment(this.changeProdList[i].startTime).format("YYYY-MM-DD HH:mm")

                    this.changeProdList[i].checkTime = this.$moment(this.changeProdList[i].checkTime).format("YYYY-MM-DD HH:mm")
                }
            })
        },
        pageClick(currentPage) {
            this.changeProdList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll()
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAll()
        },
    },
    mounted() {
        this.setDefaultPath('/changeProdStatistic')

        this.getAll()
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}
</style>